import React from 'react'
import injectStyles from 'react-jss'
import { MISSION_NO_SHOWN_STATUS } from '../../../constants'
import { StatusLabel } from '../../StatusLabel'

const styles = {
  wrapper: {
    marginLeft: 16,
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      marginTop: 0,
    },
  },
}

const NoShowBadge = ({ classes }) => {
  return (
    <div className={classes.wrapper}>
      <StatusLabel status={MISSION_NO_SHOWN_STATUS} />
    </div>
  )
}

export default injectStyles(styles)(NoShowBadge)
